import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateName = async (faId, cgId, cg_name) =>
  axios.put(
    `/api/framework_agreements/${faId}/consortium_groups/${cgId}`,
    JSON.stringify({ cg_name })
  );
const addSuppliersToConsortiumGroup = async (faId, cgId, companyIds) =>
  axios.post(
    `/api/framework_agreements/${faId}/consortium_groups/${cgId}/companies`,
    JSON.stringify({
      fa_id: +faId,
      cg_id: +cgId,
      companies_ids: companyIds,
      company_type: 'supplier',
    })
  );
const removeSupplierFromConsortiumGroup = async (faId, cgId, cgcId) =>
  axios.delete(`/api/framework_agreements/${faId}/consortium_groups/${cgId}/companies/${cgcId}
`);

const updateConsortiumGroup = async ({
  faId,
  cgId,
  cg_name = '',
  removedSuppliers = [],
  addedSuppliers = [],
}) => {
  return Promise.all([
    cg_name ? updateName(faId, cgId, cg_name) : null,
    addedSuppliers.length ? addSuppliersToConsortiumGroup(faId, cgId, addedSuppliers) : null,
    ...removedSuppliers.map((cgcId) => removeSupplierFromConsortiumGroup(faId, cgId, cgcId)),
  ]);
};

export const useUpdateConsortiumGroup = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateConsortiumGroup,
    onSuccess: () => {
      enqueueSnackbar('Consortium group was succesfully updated', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      //   refetch();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
